import { render, staticRenderFns } from "./Celebrity.vue?vue&type=template&id=c12261e0&"
import script from "./Celebrity.vue?vue&type=script&lang=js&"
export * from "./Celebrity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports